import InspectionList from "./InspectionList.jsx";

export default InspectionList;
